import { createStyles } from 'antd-style';

export const useStyles = createStyles(({ token, css }) => {
  return {
    container: css`
      flex: 0 0 auto;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #fff;
      border-radius: 20px;
      margin-top: 26px;
    `,
    title: css`
      font-size: 24px;
      font-weight: bold;
    `,
    menu: css`
      margin-right: 20px;
      cursor: pointer;
    `,
    left: css`
      display: flex;
      padding-left: 20px;
      align-items: center;
    `
  };
});
